import styled from "styled-components";

export default styled.div`
  max-height: 500px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  position: relative;
  width: 500px;
`;
